import { Divider, Text } from '@chakra-ui/react';

import { Card } from '@/imports/ui/chakra/components/Card';

type IFileNameTooltipLabelProps = {
  fileName: string;
  previewDisabled: boolean;
  fileNameLengthThreshold: number;
};

export const FileNameTooltipLabel: React.FC<IFileNameTooltipLabelProps> = ({
  fileName,
  previewDisabled,
  fileNameLengthThreshold,
}) => {
  return (
    <Card bg="gray.700">
      {fileName.length > fileNameLengthThreshold ? <Text>{fileName}</Text> : ''}
      {fileName.length > fileNameLengthThreshold && previewDisabled && (
        <Divider colorScheme="gray" />
      )}
      {previewDisabled && (
        <Text noOfLines={2}>
          Preview is not supported for this file type. Download the file to
          view.
        </Text>
      )}
    </Card>
  );
};
